import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { postData } from "../../../../Services/Api";
import { GetUserDetails } from "../../../../Helpers/Utility";
import { Modal } from "react-bootstrap";
import QRCode from "react-qr-code";
import { ColorRing } from "react-loader-spinner";
import { Value } from "sass";

export default function QRCodeModal({ show, handleClose, userData, addUid }) {
  const [isLoading, setIsloading] = useState(true);
  const [data, setData] = useState("");

  useEffect(() => {
    if (show) {
      setIsloading(true);
      getData();
    }
  }, [show]);

  const onClose = () => {
    handleClose();
    // setIsloading(true);
    // setData("");
  };

  const getData = async () => {
    setIsloading(true);
    try {
      const { token } = GetUserDetails();
      const { user_subscribers_id, location_server_id } = userData;
      const response = await postData(
        "get-vless-url",
        {
          user_subscribers_id,
          location_server_id,
        },
        {
          Authorization: `Bearer ${token}`,
        }
      );
      if (response?.data?.["vless-url"]) {
        setData(response?.data?.["vless-url"]);
        addUid(location_server_id, user_subscribers_id, response?.data?.uuid);
      } else if (response?.message) {
        onClose();
        toast.error(response?.message);
      } else {
        onClose();
        toast.error("Data not found");
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message);
      onClose();
    }
    setIsloading(false);
  };

  const copytext = () => {
    navigator.clipboard.writeText(data);
    toast.success("Link copied!");
  };

  return (
    <div>
      <Modal
        className="shadow-lg"
        show={show}
        onHide={onClose}
        centered
        size="sm"
      >
        <Modal.Header className="px-4" closeButton>
          <Modal.Title>QRCode</Modal.Title>
        </Modal.Header>
        <div className="p-3 py-4">
          {isLoading ? (
            <div className="d-flex justify-content-center py-5">
              <ColorRing
                type="ThreeDots"
                color="#00BFFF"
                height={80}
                width={80}
              />
            </div>
          ) : (
            <div className="w-full d-flex align-items-center ">
              <button
                className="mx-auto btn p-0"
                style={{ cursor: "pointer" }}
                onClick={copytext}
              >
                {data && <QRCode value={data} />}
              </button>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
}
